dmx.Component('bs-button', {

    extends: 'button',

    attributes: {
        variant: {
            type: String,
            default: 'secondary'
        },
        size: {
            type: String,
            default: 'md'
        },
        inactive: {
            type: Boolean,
            default: false
        },
        block: {
            type: Boolean,
            default: false
        }
    },

    update: function(props) {
        //this.super.update.call(this, props);
        dmx.Component('button').prototype.update.call(this, props);
        this.$node.className = this.getClasses();
    },

    getClasses: function() {
        var className = 'btn';
        className += !this.props.variant ? ' btn-secondary' : ' btn-' + this.props.variant;
        if (this.props.size) className += ' btn-' + this.props.size;
        if (this.props.block) className += ' btn-block';
        if (this.props.disabled) className += ' disabled';
        if (this.props.inactive) className += ' btn-inactive';
        return className;
    }

});
